import {useTranslation} from 'react-i18next';
import {Modal} from '../../../../../../components/modal/modal';
import {translations} from '../../../../../../i18n/translations';
import {Stack, Typography} from '@mui/material';

type QuickAccessDeactivateModalProps = {
  name: string;
  submitting: boolean;
  onClose: () => void;
  onDeactivate: () => void;
};

export default function QuickAccessDeactivateModal({
  name,
  submitting,
  onClose,
  onDeactivate,
}: QuickAccessDeactivateModalProps) {
  const {t} = useTranslation();

  return (
    <Modal
      open
      maxWidth="sm"
      fullWidth
      preventCloseClick
      onClose={onClose}
      className="deactivate-quick-access-device-modal"
      actions={[
        {
          label: t(translations.modal.cancel),
          type: 'destructive',
          onClick: onClose,
          disabled: submitting,
        },
        {
          label: t(
            translations.office.professional_caregiver.settings.quick_access.deactivate_modal.button
          ),
          type: 'nondestructive',
          onClick: onDeactivate,
          disabled: submitting,
          loading: submitting,
        },
      ]}
    >
      <Stack className="container">
        <Typography className="title">
          {t(
            translations.office.professional_caregiver.settings.quick_access.deactivate_modal.title,
            {
              name:
                name ||
                t(
                  translations.office.professional_caregiver.settings.quick_access.deactivate_modal
                    .no_name
                ),
            }
          )}
        </Typography>
        <Typography className="subtitle">
          {t(
            translations.office.professional_caregiver.settings.quick_access.deactivate_modal
              .subtitle
          )}
        </Typography>
      </Stack>
    </Modal>
  );
}
